module.exports = __webpack_public_path__ + "static/ordinace_008-9c8fd5448c03949097bee70cc14856fd.jpg";